// Ladas disponibles para teléfono/celular en los formularios de Cliente y
// Preaprobación de diseños (venta al público).
export const LADAS = [
  { codigo: "+52", bandera: "🇲🇽", label: "México (+52)" },
  { codigo: "+1", bandera: "🇺🇸", label: "EE.UU./Canadá (+1)" },
  { codigo: "+502", bandera: "🇬🇹", label: "Guatemala (+502)" },
  { codigo: "+503", bandera: "🇸🇻", label: "El Salvador (+503)" },
  { codigo: "+504", bandera: "🇭🇳", label: "Honduras (+504)" },
  { codigo: "+505", bandera: "🇳🇮", label: "Nicaragua (+505)" },
  { codigo: "+506", bandera: "🇨🇷", label: "Costa Rica (+506)" },
  { codigo: "+34", bandera: "🇪🇸", label: "España (+34)" },
  { codigo: "+57", bandera: "🇨🇴", label: "Colombia (+57)" },
  { codigo: "+58", bandera: "🇻🇪", label: "Venezuela (+58)" },
];

// Cantidad de dígitos exacta del número local (sin lada) por país.
export const LADA_LONGITUD = {
  "+52": 10, // México
  "+1": 10, // EE.UU./Canadá
  "+502": 8, // Guatemala
  "+503": 8, // El Salvador
  "+504": 8, // Honduras
  "+505": 8, // Nicaragua
  "+506": 8, // Costa Rica
  "+34": 9, // España
  "+57": 10, // Colombia
  "+58": 10, // Venezuela
};

// Quita todo lo que no sea dígito (espacios, guiones, letras, etc.)
export function soloDigitos(str) {
  return (str || "").replace(/\D/g, "");
}

// Detecta la lada de un teléfono guardado como puros dígitos (con el código
// de país pegado al inicio, sin separador fijo).
export function detectarLada(digitos) {
  const encontrada = [...LADAS]
    .sort((a, b) => b.codigo.length - a.codigo.length)
    .find((l) => digitos.startsWith(l.codigo.slice(1)));
  return encontrada?.codigo || "+52";
}
